<template>
  <div class="StaffManage-list">
    <GlobalInfoBar title="收款明细" content="统计每笔订单的收款信息明细。" />
    <GlobalChunk icon="search" title="筛选查询">
      <div slot="filter">
        <GlobalForm
          class="global-form"
          :init-data="initData"
          :form-item-list="formItemList"
          :inline="true"
          :labelWidth="100"
          :needBtnLoading="true"
          round
          @handleConfirm="handleConfirm"
          confirmBtnName="查询"
        >
          <el-form-item
            class="el_from"
            label-width="85px"
            label="收款时间"
            slot="timeSelect"
            style="margin:0"
          >
            <el-date-picker
              v-model="entryTime"
              type="daterange"
              :picker-options="pickerOptions"
              :editable="false"
              start-placeholder="开始日期"
              range-separator="~"
              end-placeholder="结束日期"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-button
            icon="el-icon-download"
            slot="AddSlot"
            type="success"
            :loading="exportLoading"
            @click="exportExcelBefore"
            >导出Excel</el-button
          >
        </GlobalForm>
      </div>
      <!-- <StaffManageTable /> -->
      <GlobalTable
        ref="GlobalTable"
        v-loading="loading"
        :columns="regiondatatitle"
        :data="this.redenvellist"
        :currentPage="page.pageNum"
        :pageSize="10"
        :total="page.total"
        @handleCurrentChange="handleCurrentChange"
      >
        <el-table-column label="原始订单号" slot="orderNo" align="center">
          <template slot-scope="{ row }">
            <div
              style="color: #0981ff;cursor: pointer;"
              @click="toOrderDetails(row)"
            >
              <span style="border-bottom: 1px solid #0981ff">{{
                row.orderNo
              }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="下单人" slot="staffName" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.staffName || "--" }}</div>
          </template>
        </el-table-column>

        <el-table-column label="收款金额" slot="amount" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.amount || "--" }}</div>
          </template>
        </el-table-column>

        <el-table-column label="收款人姓名" slot="userName" align="center">
          <template slot-scope="{ row }">
            <div>
              <span v-if="row.isDoubtStaff" class="channeltype2"
                >疑似店员</span
              >
              {{ row.userName || "--" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="收款账号/业务单号" slot="mobile" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.transferChannel=='wechat'">{{row.mobile }}</span>
            <span v-else>{{ row.alipayOrderId || row.alipayAccount || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="身份证号" slot="idNo" align="center">
          <template slot-scope="{ row }">
            <div>{{ row.idNo || "--" }}</div>
          </template>
        </el-table-column>
        <el-table-column label="身份证照片" slot="isIdCard" align="center">
          <template slot-scope="{ row }">
            <div style="color: #0981ff !important;cursor: pointer;text-decoration: underline;" @click="seeIdCard(row)" v-if="row.idcardNationalEmblemImg || row.idcardPortraitImg">点击查看</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" slot="transferStatus" align="center">
          <template slot-scope="{ row }">
            <div>{{row.transferStatus=='1'?'待审核':row.transferStatus=='2'?'放款中':row.transferStatus=='3'?'已驳回':row.transferStatus=='4'?'放款成功':row.transferStatus=='5'?'放款失败':row.transferStatus=='6'?'已失效':'微信异常'}}</div>
            <div v-if="row.errorMsg">{{row.errorMsg}}</div>
          </template>
        </el-table-column>
        <el-table-column label="收款方式" slot="transferChannel" align="center">
          <template slot-scope="{ row }">
            <span>{{row.transferChannel=='wechat'?'微信':row.transferChannel=='alipay'?'支付宝':'--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="电子签名" slot="userSignImg" align="center">
          <template slot-scope="{ row }">
            <span v-if="!row.userSignImg">--</span>
            <div v-if="row.userSignImg != null">
              <el-image
                style="width: 40px; height: 40px"
                :src="row.userSignImg"
                :preview-src-list="[row.userSignImg]"
              >
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否为黑名单收款" slot="isBlacklistStaff" align="center">
          <template slot-scope="{ row }">
            <span :style="row.isBlacklistStaff?'color:#FB7B7B;':''">{{row.isBlacklistStaff?'是':'否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="收款次数" slot="collectionNum" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.collectionNum">{{row.collectionNum}}次</div>
            <div v-if="row.collectionNum && row.transferChannel=='wechat'" class="btn" @click="examineId(row)">查看openID</div>
            <span v-else>--</span>
          </template>
          </el-table-column>
        <el-table-column label="授权人" slot="userAudit" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.userAuditPhone">{{row.userAuditName}}-{{row.userAuditPhone}}</div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">
            <div class="btn" v-if="!row.isBlacklistStaff && row.storeId" style="color: #ff687b;" @click="addBlack(row)">加入黑名单</div>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>
    <el-dialog
      class="id_card_dialog"
      title="查看身份证照片"
      :visible.sync="idCardShow"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="img-box">
        <div class="img-tips-box">
          <div
            @click="chooseImages(0)"
            class="img-tips"
            :class="imgIndex==0 ? 'img-tips-choose' : 'img-tips-default'"
          >
            身份证人像面
          </div>
          <div
            @click="chooseImages(1)"
            class="img-tips"
            :class="imgIndex==1 ? 'img-tips-choose' : 'img-tips-default'"
          >
            身份证国徽面
          </div>
        </div>
        <div class="block" style="margin-top:20px">
          <viewer :images="DialogImgList[imgIndex]">
            <el-carousel trigger="click" height="260px">
              <el-carousel-item
                v-for="(item,index) in DialogImgList[imgIndex]"
                :key="index"
              >
                <div class="sec_img">
                  <img :src="item.img" alt="" />
                </div>
              </el-carousel-item>
            </el-carousel>
          </viewer>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="closeExport">
      <div class="code-tip">
        <div class="tip-sure">是否确认导出订单？</div>
      </div>
      <div class="command">
        <div style="width: 88px;">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="closeExport">取消</el-button>
        <el-button type="primary" :loading="codeLoading" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
    <!-- 查看openid弹出框 -->
    <el-dialog class="acc_dialog" title='查看openID' :visible.sync="seeopendidShow" :close-on-click-modal="false"
      width="410px">
      <div style="margin-bottom: 20px">查看openID:</div>
      <div class="openSytle">
        <span id="123" style="margin-right: 20px;">{{ haveopenid }}</span>
        <el-tag @click="copyOpenid" size="mini">复制</el-tag>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="seeopendidShow = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加黑名单"
      :visible.sync="addBlacklistDiaVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div style="margin-bottom: 20px;">
        <span class="code-tip">说明：添加到黑名单后，若收款人填写该人员，需要授权验证才可收款</span>
      </div>
      <el-form :model="addFormData" label-width="110px">
        <el-form-item label="人员姓名">
          <el-input disabled v-model="addFormData.staffName"></el-input>
        </el-form-item>
        <el-form-item label="人员手机号">
          <el-input disabled v-model="addFormData.mobile"></el-input>
        </el-form-item>
        <el-form-item label="限制收款门店">
          <el-input disabled v-model="addFormData.storeName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addBlacklistDiaVisible = false">取消</el-button>
        <el-button
          type="primary" :loading="addBtnLoading" @click="sureAdd">确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import _api from "@/utils/request";
import { MessageBox } from "element-ui";
export default {
  components: {},
  data() {
    return {
      pageson: {
        pageNum: 1,
        total: 2,
        pageSize: 10,
      },
      ruleForm: {
        name: "",
        region: "",
      },
      initData: null,
      loading: false,
      page: {
        pageNum: 1,
        total: 10,
      },
      orderNO: "",
      BillNo: "",
      Nextperson: "",
      payee: "",
      transferChannel: "",
      isDoubtStaff: "",
      datastr: {},
      //   select form data
      formItemList: [
        {
          key: "orderNO",
          type: "input",
          labelName: "订单号",
          placeholder: "请输入订单号",
          lableWidth: "85px",
        },
        {
          key: "Nextperson",
          type: "input",
          labelName: "下单人",
          placeholder: "请输入下单人",
          lableWidth: "70px",
        },
        {
          key: "payee",
          type: "input",
          labelName: "收款人",
          placeholder: "请输入收款人",
          lableWidth: "70px",
        },
        {
          key: "isDoubtStaff",
          type: "select",
          lableWidth: "110px",
          labelName: "是否疑似店员",
          option: [
            {
              value: "",
              label: "全部",
            },
            {
              value: true,
              label: "是",
            },
            {
              value: false,
              label: "否",
            },
          ],
        },
        { slotName: "timeSelect" },
        {
          key: 'transferChannel',
          type: 'select',
          labelName: '收款方式',
          placeholder: '请选择收款方式',
          option: [
            {
              value: '',
              label: '全部',
            },
            {
              value: 'wechat',
              label: '微信',
            },
            {
              value: 'alipay',
              label: '支付宝',
            }
          ],
        },
        {
          key: 'isBlacklistStaff',
          type: 'select',
          labelName: '是否为黑名单收款',
          placeholder: '请选择',
          lableWidth: '150px',
          option: [
            {
              value: true,
              label: '是',
            },
            {
              value: false,
              label: '否',
            }
          ],
        },
      ],
      regiondatatitle: [
        { slotName: "orderNo" },
        { label: "收款时间", prop: "createTime" },
        { slotName: "staffName" },
        { slotName: "userName" },
        { slotName: "amount" },
        { slotName: "mobile" },
        { slotName: "idNo" },
        { slotName: "isIdCard" },
        { slotName: "transferStatus" },
        { slotName: "transferChannel" },
        { slotName: "userSignImg" },
      ],
      redenvellist: [],
      DialogDataList: [{ areaName: "" }],
      rules: {
        name: [
          { required: true, message: "请输入区域名称", trigger: "blur" },
          { min: 0, max: 8, message: "最多输入八个字符", trigger: "blur" },
        ],
      },

      pickerMinDate: null,
      pickerMaxDate: null,
      day31: 30 * 24 * 3600 * 1000,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          if (minDate && this.pickerMinDate) {
            this.pickerMinDate = null;
          } else if (minDate) {
            this.pickerMinDate = minDate.getTime();
          }
        },
        disabledDate: (time) => {
          if (this.pickerMinDate) {
            return (
              time.getTime() > this.pickerMinDate + this.day31 ||
              time.getTime() < this.pickerMinDate - this.day31
            );
          }
          return false;
        },
      },
      entryTime: null,
      idCardShow: false,
      DialogImgList: [[], []],
      imgIndex: 0,
      exportLoading: false,
      codeShow: false,
      codeLoading: false,
      code: "",
      seeopendidShow: false,
      haveopenid: "",
      addBlacklistDiaVisible: false,
      addBtnLoading: false,
      addFormData: {
        staffName: "",
        mobile: "",
        storeName: "",
        storeId: "",
      },
      staffBlacklistEnable: false,
    };
  },
  created() {
    this.getBlacklistConfig()
    let startTime = moment()
      .day(moment().day() - 7)
      .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推15天的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
    this.entryTime = [startTime, endTime];
    this.handleConfirm();
  },
  mounted() {},
  methods: {
    toOrderDetails(row) {
      this.$router.push({
        path: "/RecallOrder/Details",
        query: { type: "edit", id: row.orderNo },
      });
    },

    // /// 上面的注释始终代表下面的方法

    handleConfirm(data,cd) {
      if (data) {
        console.log(data);
        this.orderNO = data.orderNO;
        this.Nextperson = data.Nextperson;
        this.payee = data.payee;
        this.transferChannel = data.transferChannel;
        this.isBlacklistStaff = data.isBlacklistStaff;
        this.isDoubtStaff = data.isDoubtStaff
      }

      console.log("订单号", this.orderNO);
      console.log("下单人", this.Nextperson);
      console.log("付款人", this.payee);
      let startTime = moment(this.entryTime[0]).format("x");
      let endTime = moment(this.entryTime[1]).format("x");
      console.log("时间", startTime, endTime);
      let params = {
        orderNo: this.orderNO,
        staffName: this.Nextperson,
        userName: this.payee,
        transferChannel: this.transferChannel,
        isBlacklistStaff: this.isBlacklistStaff,
        isDoubtStaff: this.isDoubtStaff,
        startTime: startTime,
        endTime: endTime,
        pageNum: 1,
        pageSize: 10,
      };
      this.loading = true
      _api.detailgetOrderPayee(params).then((res) => {
        if (res.code == 1) {
          this.redenvellist = res.data.records;
          this.page.pageNum = res.data.current;
          this.page.total = res.data.total;
        }
        this.loading = false
        if(typeof cd ==='function'){
          cd();
        }
      });
    },
    // list翻页方法
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }

      let startTime = moment(this.entryTime[0]).format("x");
      let endTime = moment(this.entryTime[1]).format("x");
      console.log("时间", startTime, endTime);
      let params = {
        orderNo: this.orderNO,
        staffName: this.Nextperson,
        userName: this.payee,
        transferChannel: this.transferChannel,
        isBlacklistStaff: this.isBlacklistStaff,
        isDoubtStaff: this.isDoubtStaff,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.page.pageNum,
        pageSize: 10,
      };
      this.loading = true
      _api.detailgetOrderPayee(params).then((res) => {
        if (res.code == 1) {
          this.redenvellist = res.data.records;
          this.page.pageNum = res.data.current;
          this.page.total = res.data.total;
        }
        this.loading = false
      });
    },
    closeDialogStore() {},
    // 删除方法
    DelFN(row) {},

    // 门店数量点击
    storeNum(row) {},
    exportExcelBefore() {
      let userInfo = localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{}
      _api.needValid({account:userInfo.userAcc}).then(res=>{
        if(res.data){
          this.codeShow = true
        }else{
          this.exportExcel()
        }
      })
    },
    exportExcel(e) {
      let startTime = moment(this.entryTime[0]).format("x");
      let endTime = moment(this.entryTime[1]).format("x");
      let params = {
        orderNo: this.orderNO,
        staffName: this.Nextperson,
        userName: this.payee,
        isDoubtStaff: this.isDoubtStaff,
        transferChannel: this.transferChannel,
        isBlacklistStaff: this.isBlacklistStaff,
        startTime: startTime,
        endTime: endTime,
        command: this.code,
      };
      this.exportLoading = true
      _api.getOrderPayeeExcel(params).then((res) => {
        const content = res;
        const blob = new Blob([content]);

        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => {
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              MessageBox.alert(data.msg || "服务异常", "错误提示", {
                type: "error",
              });
            }
          } catch (err) {
            let start = moment(Number(params.startTime)).format("YYYY.MM.DD");
            let end = moment(Number(params.endTime)).format("YYYY.MM.DD");
            const fileName = `【收款明细】${start}-${end}.xlsx`;
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
          }
        });
        reader.readAsText(blob, "utf-8");
        this.codeShow = false
      }).finally(() => {
            this.exportLoading = false;
            this.codeLoading = false;
          });
    },
    // 查看身份证照片
    seeIdCard(row) {
      this.DialogImgList = [[{img:row.idcardNationalEmblemImg}],[{img:row.idcardPortraitImg}]]
      this.idCardShow = true
    },
    chooseImages(e) {
      this.imgIndex = e
    },
    closeExport() {
      this.codeShow = false
      this.code = ""
    },
    codeSubmit() {
      if (!this.code) {
        return this.$message.error("请输入谷歌动态码");
      }
      this.codeLoading = true
      this.exportExcel()
    },
    addBlack(row) {
      this.addBlacklistDiaVisible = true
      this.addFormData.staffName = row.userName
      this.addFormData.mobile = row.mobile
      this.addFormData.storeId = row.storeId
      this.addFormData.storeName = row.storeName
    },
    //查看openID
    examineId(row) {
      this.seeopendidShow = true
      this.haveopenid = row.openid
    },
    // 复制
    copyOpenid() {
      const haveopenid = this.haveopenid;
      const textarea = document.createElement("textarea");
      textarea.value = haveopenid;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      this.$message.success("已复制");
    },
    sureAdd() {
      this.addBtnLoading = true
      let params = {
          mobile: this.addFormData.mobile,
          staffName: this.addFormData.staffName,
          storeId: this.addFormData.storeId,
        }
        _api.addBlacklistStaff(params).then(res => {
          if(res.code === 1){
            this.$message.success('操作成功')
            this.addBlacklistDiaVisible = false
            this.handleConfirm()
          }
        }).finally(() => {
          this.addBtnLoading = false
        });
    },
    getBlacklistConfig() {
      _api.getBlacklistConfig().then(res => {
        if(res.code === 1){
          if(res.data.staffBlacklistEnable){
            this.regiondatatitle = [
              { slotName: "orderNo" },
              { label: "收款时间", prop: "createTime" },
              { slotName: "staffName" },
              { slotName: "userName" },
              { slotName: "amount" },
              { slotName: "mobile" },
              { slotName: "idNo" },
              { slotName: "isIdCard" },
              { slotName: "transferStatus" },
              { slotName: "transferChannel" },
              { slotName: "userSignImg" },
              { slotName: "isBlacklistStaff" },
              { slotName: "collectionNum" },
              { slotName: "userAudit" },
              { slotName: "operation" },
            ]
          }else{
            this.regiondatatitle = [
              { slotName: "orderNo" },
              { label: "收款时间", prop: "createTime" },
              { slotName: "staffName" },
              { slotName: "userName" },
              { slotName: "amount" },
              { slotName: "mobile" },
              { slotName: "idNo" },
              { slotName: "isIdCard" },
              { slotName: "transferStatus" },
              { slotName: "transferChannel" },
              { slotName: "userSignImg" },
              { slotName: "collectionNum" },
              { slotName: "userAudit" },
            ]
          }
          this.staffBlacklistEnable = res.data.staffBlacklistEnable
        }
      })
    },

  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.StaffManage-list {
  .button_top {
    cursor: pointer;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn {
    width: 280px;
    height: 42px;
    background: #f9fbfd;
    border: 1px solid #c1d1ff;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    .left {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      background: #0981ff;
      border-radius: 20px;
    }
    .right {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 40px;
      height: 40px;
      border-radius: 20px;
    }
  }
}

.deltop1txt {
  color: red;
  font-size: 14px;
}

.delcen2txt {
  text-align: center;
  margin-top: 20px;
}

.delbtn3 {
  padding: 40px 150px 20px 140px;
  display: flex;
  justify-content: space-between;
}

/deep/.elformitem {
  width: 360px;
}
/deep/.btnoutbox {
  width: 100%;
  //   display: flex;
  //   justify-content: space-between !important;

  margin-left: calc(50% - 75px);
  margin-bottom: 20px;
}
/deep/.btnclose {
  margin-left: 30px !important;
}

.storeNum {
  text-decoration: underline;
  cursor: pointer;
  color: #0981ff;
}
.channeltype2 {
  height: 16px;
  background: #fba516;
  border-radius: 4px;
  padding: 2px;
  line-height: 20px;
  font-size: 12px;
  color: #ffffff;
  margin-right: 6px;
}
.id_card_dialog{
  .img-box {
    margin-bottom: 20px;
    // 图片
    .imgs-num {
      text-align: center;
      margin: 5px 0;
      font-weight: bold;
    }
    .img-tips-box {
      display: flex;
      width: max-content;
      height: 30px;
      border: 1px solid #0981ff;
      .img-tips {
        width: 120px;
        text-align: center;
        line-height: 30px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .img-tips-default {
        background: #fff;
        color: #0981ff;
      }
      .img-tips-choose {
        background: #0981ff;
        color: #fff;
      }
    }
  }
}
.command {
  display: flex;
  align-items: center;
}

.command .el-input {
  width: 80%;
}
.code-tip {
  color: #ff8080;
  font-size: 14px;
  margin-bottom: 20px;

  .tip-sure {
    margin-top: 10px;
    color: #333333;
    font-size: 16px;
    text-align: center;
  }
}
.btn{
  color: #0981FF;
  text-decoration: underline;
  cursor: pointer;
}
</style>
